module.exports = __webpack_public_path__ + "img/i-role-min2.33760a2a.png";